























































import Component, { mixins } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import AddMasterDialog from "@/components/master/AddMasterDialog.vue";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import { HeaderItem } from "@/types";
import AxiosMixin from "@/mixins/axiosMixin";
import ResultDialog from "@/components/master/ResultDialog.vue";

interface Linkup {
  id: number;
  yearmonth: string;
  yearmonth_disp: string;
  base_date: string;
  base_date_disp: string;
  updated_at: string;
  updated_at_disp: string;
}

@Component({
  components: {
    AddMasterDialog,
    LoadingDialog,
    ResultDialog
  }
})
export default class Master extends mixins(AxiosMixin) {
  private headerItems: HeaderItem[] = [
    {
      value: "yearmonth_disp",
      text: "サービス提供年月"
    },
    {
      value: "base_date_disp",
      text: "利用者基準日"
    },
    {
      value: "updated_at_disp",
      text: "取得日"
    }
  ];

  private get button_ctrl() {
    return window.button_ctrl;
  }

  private manageYears: Linkup[] = [];

  @Ref("dialog") private readonly refDialog!: AddMasterDialog;

  @Ref("resultDialog") private readonly refResultDialog!: ResultDialog;

  created() {
    this.updateData();
  }

  private updateData() {
    this.postJsonCheck(window.base_url + "/api/office/master/get", {}, res => {
      this.manageYears = res.data.linkups;
    });
  }

  private clickAddManagement() {
    this.refDialog.open();
  }

  private clickUpdManagement(item: Linkup) {
    this.refDialog.openUpdate(item.yearmonth, item.base_date, item.updated_at);
  }

  private openResultDialog(message: string) {
    this.refResultDialog.open(message);
  }

  private clickOwnExpense(item: Linkup) {
    this.postJson(
      window.base_url + "/api/office/link/ownexpense",
      {
        base_date: item.base_date,
        year_month: item.yearmonth.replace("-", ""),
        updated_at: item.updated_at
      },
      res => {
        //IBR-640対応 エラーの場合は画面をリロードする
        if (res.data.code > 0) {
          alert(res.data.message + "\n\n画面を更新します。");
          location.reload();
          return;
        }
        this.updateData();
        this.openResultDialog(res.data.message);
      }
    );
  }
}
